<!-- HEADER & STEPPER -->
<div class="mb-6 px-3">
  <div class="w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3 mb-6">
    <div class="border-l-4 border-gray-800 pl-4">
      <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
        Social Posts Section
      </p>
      <h2 class="mt-1 text-2xl font-bold leading-tight tracking-tight text-gray-900">
        Upload Bulk
      </h2>
    </div>
  </div>

  <!-- Stepper -->
  <div class="w-full 2xl:w-3/4">
    <app-stepper-grid></app-stepper-grid>
  </div>
</div>

<!-- CONTENT WRAPPER -->
<div class="bg-gray-50 px-3 pb-10 min-h-screen pt-6">
  <!-- Content Grid -->
  <div class="grid grid-cols-12 gap-6 items-start">
    <div class="col-span-12 2xl:col-span-9 p-8 bg-white rounded-3xl border border-gray-200 flex flex-col h-[510px]">

      <div class="flex flex-col justify-between items-center h-full mb-6 relative">
        <div>
          <h1 class="text-3xl font-bold text-gray-800 tracking-tight">
            Download the XLSX file
          </h1>
        </div>
        <div class="flex-grow flex items-center justify-center">
          <div
            class="p-8 border-2 border-dashed border-gray-300 rounded-2xl text-center transition-colors cursor-pointer hover:border-blue-500 w-full max-w-xl">
            <div class="flex flex-col items-center">

              <svg class="w-11 h-11 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path>
              </svg>

              <p class="mt-4 text-gray-700 font-medium">Download the XLSX file and fill it in</p>
              <p class="text-sm text-gray-400 mt-1">Use Excel or Google Sheets to complete the template</p>

              <button type="button"
                class="mt-4 px-6 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition"
                (click)="downloadXlsxTemplate()">
                Download XLSX
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-end mt-auto">
        <button (click)="submit()"
        type="button"
          class="cursor-pointer inline-flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-blue-600 to-blue-500 text-white text-sm font-semibold rounded-lg shadow-md hover:from-blue-700 hover:to-blue-600 transition-all transform hover:scale-105">
          Next
        </button>
      </div>
    </div>

    <div class="hidden 2xl:block col-span-12 2xl:col-span-3 h-full">
      <app-bulk-sidebar></app-bulk-sidebar>
    </div>
  </div>
</div>
